import { createSlice } from "@reduxjs/toolkit";
import { showNotification } from "./notificationSlice";
import { factory } from "../../api/apiFactory";
import { downloadFile, getExportErrorMessage } from "../../helpers/exportFile";
const epaymentTransactionsApi = factory.get("epaymentTransactions");
const initialState = {
  searchBody: {},
  epaymentTransactions: {
    loading: false,
    data: [],
    total: 0,
    total_amount: 0,
    total_debt: 0,
  },
};

export const epaymentTransactionsSlice = createSlice({
  name: "epaymentTransactions",
  initialState,
  reducers: {
    setDataTable: (state, { payload }) => {
      state.epaymentTransactions.data = payload.data.data;
      state.epaymentTransactions.total = payload.data.total;
      state.epaymentTransactions.total_amount = payload.data.total_amount;
      state.epaymentTransactions.total_debt = payload.data.total_debt;
    },

    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },

    setSearchBody: (state, { payload }) => {
      state.searchBody = payload;
    },
  },
});

export const { setLoading, setDataTable, setSearchBody } =
  epaymentTransactionsSlice.actions;

export default epaymentTransactionsSlice.reducer;

//axios
const getAll = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("epaymentTransactions"));
    const res = await epaymentTransactionsApi.getAll(params);
    dispatch(setDataTable(res));
    dispatch(setLoading("epaymentTransactions"));
  } catch (err) {
    dispatch(setLoading("epaymentTransactions"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};
const epaymentTransactionsExportExcel = (params) => async (dispatch) => {
  try {
    dispatch(setLoading("epaymentTransactions"));
    const res = await epaymentTransactionsApi.export({
      ...params,
      is_excel: 1,
    });
    await downloadFile(res, `epayment_transactions.xlsx`);
    dispatch(setLoading("epaymentTransactions"));
  } catch (err) {
    dispatch(setLoading("epaymentTransactions"));
    dispatch(
      showNotification({
        message: await getExportErrorMessage(err),
        type: "error",
      })
    );
    throw new Error(err);
  }
};

// Manual Confirm App2App logic moved from externalOrdersSlice
const manualConfirmApp2app = (data, searchBody) => async (dispatch) => {
  try {
    dispatch(setLoading("epaymentTransactions"));
    const res = await epaymentTransactionsApi.manualConfirmApp2app(data);
    dispatch(setLoading("epaymentTransactions"));
    dispatch(getAll(searchBody));
    dispatch(
      showNotification({ message: "تم التعديل بنجاح", type: "success" })
    );
    return Promise.resolve(res.data);
  } catch (err) {
    dispatch(setLoading("epaymentTransactions"));
    dispatch(
      showNotification({
        message: err?.response?.data?.errors?.[0] ?? "An error occurred",
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const EpaymentTransactions = {
  getAll,
  epaymentTransactionsExportExcel,
  manualConfirmApp2app,
};
